const LeadStatusSkeleton = () =>{
    return(
    <div className="bg-white flex flex-col item-start shadow-lg rounded-lg p-4 mb-4 w-full h-fit">
      <div className="h-6 w-48 bg-gray-200 rounded animate-pulse mb-4"></div>
      <div className="flex flex-row justify-between">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="bg-gray-100 rounded-lg p-4 m-4 w-1/4 h-24 animate-pulse">
            <div className="h-4 w-20 bg-gray-200 rounded mb-2"></div>
            <div className="h-3 w-16 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    </div>
    )
}

const YoursTableSkeleton = () => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
        <thead>
          <tr className="text-gray-400 border-t">
            <th className="py-2 px-4 border-b text-left w-1/12">ID</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Product</th>
            <th className="py-2 px-4 border-b text-left w-3/12">Name</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Lead Status</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Pipeline Stage</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Lead Source</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Last Interacted</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Action</th>
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

const LeadInventoryPaginationSkeleton = () => {
  return (
      <div className="flex justify-between items-center border-t border-gray-200 p-4">
          <div className="flex flex-row gap-2">
              <div className="h-5 w-48 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-5 w-40 bg-gray-200 rounded animate-pulse"></div>
          </div>
          <div className="flex gap-1">
              <div className="h-8 w-32 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-20 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-24 bg-gray-200 rounded animate-pulse"></div>
              <div className="h-8 w-8 bg-gray-200 rounded animate-pulse"></div>
          </div>
      </div>
  );
};

const AllTableSkeleton = () => {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border-b border-gray-200 table-fixed">
        <thead>
          <tr className="text-gray-400 border-t">
            <th className="py-2 px-4 border-b text-left w-1/12">ID</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Product</th>
            <th className="py-2 px-4 border-b text-left w-3/12">Name</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Lead Status</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Pipeline Stage</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Lead Source</th>
            <th className="py-2 px-4 border-b text-left w-2/12">Last Interacted</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Owner</th>
            <th className="py-2 px-4 border-b text-left w-1/12">Action</th>
          </tr>
        </thead>
        <tbody>
          {[...Array(5)].map((_, index) => (
            <tr key={index} className="hover:bg-gray-100">
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
              <td className="py-2 px-4 border-b">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export {LeadStatusSkeleton, YoursTableSkeleton, LeadInventoryPaginationSkeleton, AllTableSkeleton};